import { createSlice } from "@reduxjs/toolkit";

const NMhotlistSlice = createSlice({
  name: "NMHotlist",
  initialState: {
    loading: false,
    hotlists: [],
    totalCount: 0,
    error: null,
  },
  reducers: {
    getHotlists: (state, action) => {
      state.loading = true;
      state.error = null;
    },
    getHotlistsSuccess: (state, action) => {
      state.loading = false;
      state.hotlists = action.payload.data || [];
      state.totalCount =
        action.payload.total ||
        (action.payload.data ? action.payload.data.length : 0);
      state.error = null;
    },
    getHotlistsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    addHotlist: (state) => {
      state.loading = true;
      state.error = null;
    },
    addHotlistSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    addHotlistFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteHotlistRecord: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteHotlistRecordSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    deleteHotlistRecordFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteHotlistRecords: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteHotlistRecordsSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    deleteHotlistRecordsFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    deleteHotlist: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteHotlistSuccess: (state) => {
      state.loading = false;
      state.error = null;
    },
    deleteHotlistFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getHotlists,
  getHotlistsSuccess,
  getHotlistsFailure,
  addHotlist,
  addHotlistSuccess,
  addHotlistFailure,
  deleteHotlistRecord,
  deleteHotlistRecordSuccess,
  deleteHotlistRecordFailure,
  deleteHotlistRecords,
  deleteHotlistRecordsSuccess,
  deleteHotlistRecordsFailure,
  deleteHotlist,
  deleteHotlistSuccess,
  deleteHotlistFailure,
} = NMhotlistSlice.actions;

export default NMhotlistSlice.reducer;
